module.exports = __webpack_public_path__ + "static/flux-persona-1-78bfc71046fcd8316c991ba07e448268.png";